import type { FlyUIEnvironment, TopBannerConfig } from "@wayflyer/flyui";
import { IconInfoCircle16Line } from "@wayflyer/flyui-icons/16/line";
import { getEnvironment, isProductionEnvironment } from "shared-utils";

export const isStorybook = () => getEnvironment() === "storybook";

/**
 * The `environment` prop for `FlyUIProvider`: a critical "Production" tag shown to staff
 * in production, and nothing anywhere else. Pass `isStaff` from the app's user
 * context; the staff app can pass `true`, as every user there is staff.
 */
export const getFlyUIEnvironment = ({ isStaff }: { isStaff: boolean }): FlyUIEnvironment | undefined =>
  isStaff && isProductionEnvironment() ? { label: "Production", status: "critical" } : undefined;

/**
 * `topBanners` entries for `NavigationProvider` warning that the app isn't running on the
 * production environment. Empty in production, so callers can spread the result straight
 * into their own `topBanners` array regardless of environment. Pass the same `id` across
 * callers that share dismissal state (e.g. two shells of the same app).
 */
export const getDevelopmentEnvironmentTopBanners = ({ id }: { id: string }): TopBannerConfig[] =>
  isProductionEnvironment()
    ? []
    : [
        {
          id,
          message: "DEVELOPMENT ENVIRONMENT",
          icon: IconInfoCircle16Line,
          color: "warning",
          size: "large",
          enableDismissForSession: true,
          matchRoutes: ["*"],
        },
      ];
